var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogAndEventManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      marginRight: 10
    },
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 18900 14000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsxodm: "http://www.corel.com/coreldraw/odm/2003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545A6D",
    fillRule: "nonzero",
    d: "M2800 10150c-420,0 -700,280 -700,700 0,420 280,700 700,700 420,0 700,-280 700,-700 0,-420 -280,-700 -700,-700zm2800 -10150c-2800,0 -5600,980 -5600,2800l0 8400c0,1820 2800,2800 5600,2800 2800,0 5600,-980 5600,-2800l0 -8400c0,-1890 -2800,-2800 -5600,-2800zm4200 11200c0,490 -1610,1400 -4200,1400 -2590,0 -4200,-910 -4200,-1400l0 -2310c1330,630 2730,910 4200,910 1470,70 2870,-280 4200,-910l0 2310zm0 -4200c0,490 -1610,1400 -4200,1400 -2590,0 -4200,-910 -4200,-1400l0 -2310c1330,630 2730,910 4200,910 1470,70 2870,-280 4200,-910l0 2310zm-4200 -2800c-2590,0 -4200,-910 -4200,-1400 0,-490 1610,-1400 4200,-1400 2590,0 4200,910 4200,1400 0,490 -1540,1400 -4200,1400zm-2800 1750c-420,0 -700,280 -700,700 0,420 280,700 700,700 420,0 700,-280 700,-700 0,-420 -280,-700 -700,-700z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#545A6D",
    fillRule: "nonzero",
    x: 10290,
    y: 6720,
    width: 5950,
    height: 1400
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A6D",
    fillRule: "nonzero",
    points: "16240,12810 13510,12810 13510,2100 16240,2100 16240,3500 14910,3500 14910,11410 16240,11410 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545A6D",
    fillRule: "nonzero",
    d: "M16940 3990l1470 0c280,0 490,-210 490,-560l0 -1330c0,-280 -210,-560 -490,-560l-1470 0c-280,0 -490,280 -490,560l0 1330c0,350 210,560 490,560z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545A6D",
    fillRule: "nonzero",
    d: "M16940 8680l1470 0c280,0 490,-210 490,-560l0 -1330c0,-280 -210,-560 -490,-560l-1470 0c-280,0 -490,210 -490,560l0 1330c0,280 210,560 490,560z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545A6D",
    fillRule: "nonzero",
    d: "M16940 13300l1470 0c280,0 490,-210 490,-560l0 -1330c0,-280 -210,-560 -490,-560l-1470 0c-280,0 -490,210 -490,560l0 1330c0,350 210,560 490,560z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogAndEventManagement);
export default __webpack_public_path__ + "static/media/log-and-event-management.91dce4595cdd901bd2543a880cf70e5a.svg";
export { ForwardRef as ReactComponent };